import type { ThemeId } from "@dexibit/styles";

// Dev-only theme opt-in. Dark mode is not yet exposed to users; a tester enables
// it per-browser via:
//   localStorage.setItem("dx-theme", "gaea-dark")
// then reloads. Absent/invalid value falls back to the default (light) theme.
const DEXIBIT_THEME_STORAGE_KEY = "dx-theme";

const DEFAULT_THEME: ThemeId = "accesso-light";
const VALID_THEME_IDS: readonly ThemeId[] = ["accesso-light", "gaea-light", "gaea-dark"];

const getDexibitTheme = (): ThemeId => {
  try {
    const value = window.localStorage.getItem(DEXIBIT_THEME_STORAGE_KEY);
    return value && (VALID_THEME_IDS as string[]).includes(value)
      ? (value as ThemeId)
      : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
};

export default getDexibitTheme;
